var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bio-project-materials-modal"
    }
  }, [_vm.isInBioMaterials ? _c('a', {
    attrs: {
      "id": "associate-link"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.displayModal.apply(null, arguments);
      }
    }
  }, [_vm._v("Associate Biological Materials to Projects")]) : _c('VButton', {
    staticClass: "pill-primary",
    attrs: {
      "enable-prevent": true
    },
    on: {
      "click": _vm.displayModal
    }
  }, [_vm._v("\n    Associate Materials\n  ")]), _vm._v(" "), _c('QueryModals', {
    attrs: {
      "group-nid": _vm.groupNid,
      "default-project-nid": _vm.defaultProjectNid,
      "is-in-bio-materials": _vm.isInBioMaterials,
      "enable-bio-material-type-select": true,
      "show-modal": true
    },
    on: {
      "associate-materials": _vm.displayAssociate
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }